/* Watches Limited — small behaviours on top of Horizon */
(function () {
  function headerHeight() {
    var h = document.querySelector('#header-group .header-section, #header-group header');
    if (!h) return 0;
    return getComputedStyle(h).position === 'sticky' ? h.getBoundingClientRect().height : 0;
  }
  // After a filter/sort change, bring the results back to the top of the screen
  function scrollToResults() {
    var target = document.querySelector('results-list, #ResultsList, .collection-wrapper');
    if (!target) return;
    var top = target.getBoundingClientRect().top + window.scrollY - headerHeight() - 8;
    if (window.scrollY > top + 4) window.scrollTo({ top: Math.max(top, 0), behavior: 'instant' });
  }
  function isFacetsDialog(el) {
    return el && el.tagName === 'DIALOG' && !!el.querySelector('facets-form-component');
  }
  function drawerScroller(d) {
    if (!d) return null;
    if (d.scrollHeight > d.clientHeight) return d;
    return [].slice.call(d.querySelectorAll('*')).find(function (e) {
      return e.scrollHeight > e.clientHeight + 10 && /(auto|scroll)/.test(getComputedStyle(e).overflowY);
    }) || d;
  }
  function drawerToTop(d, smooth) {
    var s = drawerScroller(d);
    if (s && s.scrollTop > 0) s.scrollTo({ top: 0, behavior: smooth ? 'smooth' : 'instant' });
  }
  // Opening the drawer: Safari focuses the first checkbox in DOM order (Availability → "In stock"),
  // which sits below Brand, and scrolls the drawer down to it. Put focus on the close button instead
  // and keep the drawer at the top.
  function onDrawerOpen(d) {
    var closeBtn = d.querySelector('button[aria-label*="lose" i], .dialog-close-button, button.facets__close');
    var active = document.activeElement;
    if (active && d.contains(active) && active.tagName === 'INPUT') {
      try { active.blur(); } catch (e) {}
    }
    if (closeBtn) { try { closeBtn.focus({ preventScroll: true }); } catch (e) {} }
    drawerToTop(d, false);
    [40, 120, 300, 600].forEach(function (t) { setTimeout(function () { drawerToTop(d, false); }, t); });
  }
  var mo = new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      if (m.attributeName === 'open' && m.target.open && isFacetsDialog(m.target)) onDrawerOpen(m.target);
    });
  });
  function observeDialogs() {
    document.querySelectorAll('dialog').forEach(function (d) {
      if (!d.__wlObserved) { d.__wlObserved = true; mo.observe(d, { attributes: true, attributeFilter: ['open'] }); }
    });
  }
  observeDialogs();
  new MutationObserver(observeDialogs).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('toggle', function (e) {
    if (isFacetsDialog(e.target) && e.target.open) onDrawerOpen(e.target);
  }, true);
  // After ticking a filter (e.g. Mens Watches below the Brand list), slide the drawer back to the top
  document.addEventListener('filter:update', function () {
    var d = document.querySelector('dialog[open]');
    if (isFacetsDialog(d)) { setTimeout(function () { drawerToTop(d, true); }, 150); setTimeout(function () { drawerToTop(d, true); }, 700); }
    setTimeout(scrollToResults, 50);
    setTimeout(scrollToResults, 400);
    setTimeout(scrollToResults, 1000);
  });
  // Mobile: the filter drawer applies on close — scroll the page then as well
  document.addEventListener('close', function (e) {
    if (isFacetsDialog(e.target)) setTimeout(scrollToResults, 50);
  }, true);
})();
